@if (auth.user$ | async; as user) {
  <button mat-button [matMenuTriggerFor]="menu" class="user-menu-trigger !h-auto !py-1 !px-2">
    <span class="flex items-center gap-2">
      <img src="./assets/img/user.png" alt="" class="user-avatar">
      <span class="hidden sm:flex flex-col items-start leading-tight text-left">
        <strong class="text-sm">{{ user.firstName }} {{ user.lastName }}</strong>
        <span class="mat-body-small opacity-70">{{ user.role }}</span>
      </span>
      <mat-icon class="!m-0">arrow_drop_down</mat-icon>
    </span>
  </button>

  <mat-menu #menu="matMenu" xPosition="before">
    <div class="px-4 py-2 sm:hidden">
      <strong>{{ user.firstName }} {{ user.lastName }}</strong>
      <div class="mat-body-small opacity-70">{{ user.role }}</div>
    </div>
    @if (cs.userMenu$ | async; as items) {
      @for (m of items; track m.label) {
        @if (m.visible) {
          <button mat-menu-item (click)="select(m)">
            @if (m.icon) {
              <mat-icon [class.mat-text-warn]="m.color === 'warn'">{{ m.icon }}</mat-icon>
            }
            <span [class.mat-text-warn]="m.color === 'warn'">{{ m.label | translate }}</span>
          </button>
        }
      }
    }
  </mat-menu>
}
